import React from "react";
import GoogleMapReact from "google-map-react";
import Marker from "./marker";
const CustomMap = ({ markers = [] }) => {
  return (
    <div style={{ height: "80vh", width: "100%" }}>
      <GoogleMapReact
        defaultZoom={10}
        defaultCenter={[47.91894927229234, 106.91759660338]}
        bootstrapURLKeys={{
          key: "AIzaSyCQzg_dNMu26Setxf42hyHxERNaHztzwtY",
        }}
        onClick={() => {}}
      >
        {markers.map((value, index) => {
          return (
            <Marker
              key={index}
              lng={value.lng}
              lat={value.lat}
              text={value.name}
            />
          );
        })}
      </GoogleMapReact>
    </div>
  );
};

export default CustomMap;
